var map = {
	"./s1.jpg": "397a",
	"./s2.jpg": "b285",
	"./s3.jpg": "0de1",
	"./s4.jpg": "f907",
	"./s5.jpg": "dcd7",
	"./s6.jpg": "5a0f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db6f";